module.exports = "/packs/course-small-director-a8aa939ee704e7d99729bb066ae4bea0.png";